import React, { useState } from "react";
import { StyledHeader } from "./Header.styled";
import { Avatar, AvatarDimensionsEnum } from "../core/Avatar/Avatar";
import { ReactComponent as UserIcon } from "../../icons/user.svg";
import { ReactComponent as UserImpersonateIcon } from "../../icons/impersonateUser.svg";
import { PopoverComponent } from "../core/PopoverComponent/PopoverComponent";
import { UserPanel } from "../UserPanel/UserPanel";
import { useAppSelector } from "../../hooks/store.hook";
import { Breadcrumb } from "../core/Breadcrumb/Breadcrumb";
import { getInitials } from "../../utils/collaborators.utils";
import { NotificationPanel } from "../NotificationPanel/NotificationPanel";
import { theme } from "../../constants/StyledComponents";
import { IconSizeEnum } from "../../types/AppTypes";
import { IconManager } from "../core/IconManager/IconManager";
import { ReactComponent as MenuIcon } from "../../icons/menu.svg";

type HeaderProps = {
  loadAppData: () => Promise<void>;
  setDataLoaded: (loaded: boolean) => void;
  logout: () => void;
  onOpenSidebar: () => void;
};

export const Header = ({
  loadAppData,
  setDataLoaded,
  logout,
  onOpenSidebar,
}: HeaderProps) => {
  const { profile, parentUser } = useAppSelector((state) => state.user);
  const [visiblePopover, setVisiblePopover] = useState(false);

  return (
    <StyledHeader>
      <Breadcrumb />
      <div className="right-content">
        <NotificationPanel />
        <div className="burger-menu-mobile">
          <IconManager size={IconSizeEnum.MEDIUM} onClick={onOpenSidebar}>
            <MenuIcon />
          </IconManager>
        </div>
        <PopoverComponent
          visible={visiblePopover}
          setVisible={setVisiblePopover}
          content={
            <UserPanel
              visible={visiblePopover}
              setVisible={setVisiblePopover}
              loadAppData={loadAppData}
              setDataLoaded={setDataLoaded}
              logout={logout}
            />
          }
        >
          <div className="avatar-wrapper">
            <Avatar
              variant={AvatarDimensionsEnum.SMALL}
              icon={parentUser ? <UserImpersonateIcon /> : <UserIcon />}
              collaboratorId={profile.id}
              initials={getInitials(profile.name, profile.surname)}
              badgeColor={
                parentUser ? theme.colors.grey_2 : theme.colors.purple
              }
            />
          </div>
        </PopoverComponent>
      </div>
    </StyledHeader>
  );
};
